module.exports = __webpack_public_path__ + "static/media/logo_ibl_branca_nova.fc1452f5.png";